import { Box } from "@mui/material";
import React from "react";
import Destination from "../Destination/Destination";
import Verticals from "../Verticals/Verticals";
import Hiring from "../Hiring/Hiring";
import Ourpartners from "../Ourpartners/Ourpartners";

function Aboutus() {
  return (
    <Box>
      <Box>
        <Destination />
      </Box>
      <Box>
        <Verticals />
      </Box>
      <Box>
        <Ourpartners />
      </Box>
      <Box>
        <Hiring />
      </Box>
    </Box>
  );
}

export default Aboutus;
